import React, { Component } from 'react';
import RewardListItem from '../RewardListItem/RewardListItem';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class MerchantDetailPage extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            loading:true
        };
    }

    componentDidMount() {
        
        const url = 'https://api.glippy.com/v1/profile';
        const that = this;

        fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-User-Email':'test@test.com',
                    'X-User-Token':'g14NHohYNLouJ6HxdYor',
                },
            })
        .then((response) => {
            return response.json();
        })
    
        .then((data) => {
            this.setState({
                data: data,
                loading: false
            })
        })
        .catch((error) => console.log(error));
    }

    render(){
        var hasDiscounts;
        var merchant = {
            name:"",
            image_logo: {
                url: ""
            },
            street: "",
            discounts:[]
        } 
        if(this.state.data && this.props.match){
            var selectedMerchant = this.props.match.params.id;
            merchant = this.state.data.merchants.find(function(item) {
                return item.id === parseInt(selectedMerchant);
              })
            hasDiscounts = merchant.discounts.length ? true : false;
        }

        

        return (

        this.state.loading ? <div className="loading">loading</div> :

        <div className="merchant-detail-page">

            <div className="merchant-show-page-info-wrapper">
                <img className="merchant-logo" src={merchant.image_logo.url} />
                <div className="merchant-info-wrapper">
                    <div className="merchant-name">{merchant.name}</div>
                    <div className="merchant-street">{merchant.street}</div>
                    <div className="merchant-dist-rewards-wrapper">
                        <div className="rewards-awailable">1 Reward Available</div>
                        <div className="divider"></div>
                        <div className="rewards-awailable">2.5 Miles</div>
                    </div>
                </div>
            </div> 
            <div className="merchant-show-rewards-header">
                    Your Available Rewards
                </div>
            <div className="rewards-list-wrapper">
            {hasDiscounts ? merchant.discounts.map((discount, i) => (                
                <RewardListItem key={i} reward={discount} rewardLevel={this.state.data.award_level}/>
            )) : <div>no discounts for this merchant</div>}
            </div>
        </div>
        )
    }
    
}



export default MerchantDetailPage;


// WEBPACK FOOTER //
// ./src/components/MerchantDetail/MerchantDetail.js